import { render, staticRenderFns } from "./imgTree.vue?vue&type=template&id=ab20a006&scoped=true&"
import script from "./imgTree.vue?vue&type=script&lang=js&"
export * from "./imgTree.vue?vue&type=script&lang=js&"
import style0 from "./imgTree.vue?vue&type=style&index=0&id=ab20a006&prod&lang=scss&scoped=true&"
import style1 from "./imgTree.vue?vue&type=style&index=1&id=ab20a006&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab20a006",
  null
  
)

export default component.exports